"use strict";

exports.__esModule = true;
exports.default = identity;

function identity(x) {
  return x;
}